var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTorus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#023b94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b4cb5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Torus",
    transform: "translate(9661.5 -4184.054)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5902",
    "data-name": "Ellipse 5902",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(-9661 4217.554) rotate(-90)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_964",
    "data-name": "Ellipse 964",
    cx: 15.81,
    cy: 15.81,
    r: 15.81,
    transform: "translate(-9660.31 4185.245)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_70372",
    "data-name": "Group 70372",
    transform: "translate(58.835 -93.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42974",
    "data-name": "Path 42974",
    d: "M1.954,27A1.95,1.95,0,0,0,0,28.947v2.268a1.95,1.95,0,0,0,1.954,1.947H5.412V45.847a1.95,1.95,0,0,0,1.954,1.947H9.643A1.951,1.951,0,0,0,11.6,45.847v-16.9A1.95,1.95,0,0,0,9.643,27H1.954Z",
    transform: "translate(-9713 4257.552)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42975",
    "data-name": "Path 42975",
    d: "M35.049,33.161a3.081,3.081,0,1,0-3.093-3.08A3.086,3.086,0,0,0,35.049,33.161Z",
    transform: "translate(-9731.812 4257.552)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTorus);
export default __webpack_public_path__ + "static/media/logo-torus.ae8f13a41ff80ee21ced2244e1255632.svg";
export { ForwardRef as ReactComponent };